<template>
  <section class="form-list">
    <el-form class="form form-max" ref="form" label-width="100px">
      <el-form-item label="专栏门店">
        <span class="title">{{ courseColumn.store_name }}</span>
      </el-form-item>

      <el-form-item label="专栏名称">
        <span class="title">{{ courseColumn.course_column_name }}</span>
      </el-form-item>

      <el-form-item label="预约时间">
        <span class="title">{{courseColumn.start_time | timeToYmdHi}}</span>
      </el-form-item>

      <el-form-item label="总课时数">
          <span class="title button-margin">
            <span class="primary-color count-number sign-in-count">{{ courseColumn.course_count }}</span> 节
          </span>
        <v-list-button icon="menu-course" name="查看课程" size="large" :to="RouteConfig.courseList.to('', { course_column_id: id, start_date: '', end_date: '' })"/>
      </el-form-item>

      <el-form-item label="次卡扣卡次数">
          <span class="title">
            <span class="primary-color count-number sign-in-count">{{ courseColumn.decrement_number | toYuan }}</span> 次
          </span>
      </el-form-item>

      <el-form-item label="通卡扣卡天数">
          <span class="title">
            <span class="primary-color count-number sign-in-count">{{ courseColumn.decrement_days | toYuan }}</span> 天
          </span>
      </el-form-item>

      <el-form-item label="预约上限">
          <span class="title">
            <span class="primary-color count-number sign-in-count">{{courseColumn.student_number}}</span> 人
          </span>
      </el-form-item>

      <el-form-item class="last-form-item" label="人数统计">
        <div class="count-box">
          <div>已预约</div> <span class="count-number">{{ courseColumn.students.length || 0 }}</span>
          <span class="button-margin"> 人</span>

          <v-list-button icon="mini-app-qr-code" name="小程序码" size="large" @click="getQrCode(id, isMobile ? this.qrCode : false)" :is-loading="isGetting[id]"/>
        </div>
      </el-form-item>
    </el-form>

    <v-table
      :count="count"
      :list="courseColumn.students"
      :is-loading="isLoading"
      :push-list="RouteConfig.courseColumnManage.push"
      default-order-by="sign_in_time"
      :query-list="queryList"
      :is-hide-filter="true"
      :is-not-top-list="true"
    >
      <el-table-column type="expand" v-if="!is2k">
        <template v-slot="{ row }">
          <el-form label-position="left" inline class="table-expand">
            <el-form-item label="预约时间">
              <span>{{ row.sign_in_time | timeToYmdHi }}</span>
            </el-form-item>
            <el-form-item label="排队时间">
              <span>{{ row.queue_time | timeToYmdHi }}</span>
            </el-form-item>
            <el-form-item label="所属学员">
              <v-avatar-nickname
                :value="row.selfie"
                :nickname="row.student_name"
                :is-center="true"
                :nickname-overflow="true"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="row.id"
                :avatar-size="50"
              />
            </el-form-item>
            <el-form-item label="所用课卡">
              <span v-if="row.card_id">{{ row.card_name }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="身份证号">
              <span v-if="row.id_number">{{ row.id_number }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="课卡扣次">
              <span v-if="row.card_id">{{ row.decrement_number | toYuan }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="剩余次数">
              <span v-if="row.is_number_limit">{{ row.expire_number | toYuan }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="失效日期">
              <span>{{ row.expire_time | timeToYmd }}</span>
            </el-form-item>
            <el-form-item label="微信支付订单号">
              <span v-if="row.we_chat_order_id">{{ row.out_trade_no }}</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="实际支付金额">
              <span v-if="row.we_chat_order_id">{{ row.payer_total | toYuan }} 元</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="退款金额">
              <span v-if="row.we_chat_order_id">{{ row.payer_refund | toYuan }} 元</span>
              <span v-else>-</span>
            </el-form-item>
            <el-form-item label="退款状态">
              <template v-if="row.refund_id">
                <el-tag v-if="row.is_reject" type="danger">申请失败</el-tag>
                <template v-else>
                  <el-tag v-if="!row.status">申请中</el-tag>
                  <template v-else>
                    <el-tag
                      v-for="refundState in findRefundState(row.status)"
                      :key="`expandRefundState${refundState.value}`"
                      :type="refundState.tagType"
                    >
                      {{ refundState.name }}
                    </el-tag>
                  </template>
                </template>
              </template>
            </el-form-item>
            <el-form-item label="预约状态">
              {{ (courseColumn.decrement_number && !row.card_id && !row.we_chat_order_id) ? '试课' : getReservationShortNameByState(row.reserve_state) }}
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <v-column-time value="预约时间" field="reserve_time"/>

      <el-table-column label="排队时间" v-if="isPc">
        <template v-slot="{ row }">
          <span>{{ row.queue_time | timeToYmdHi }}</span>
        </template>
      </el-table-column>

      <v-column-student label="所属学员" link-page-id="student_id"/>
      <el-table-column label="所用课卡">
        <template v-slot="{ row }">
          <span v-if="row.card_id">{{ row.card_name }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="身份证号" v-if="isPc">
        <template v-slot="{ row }">
          <span v-if="row.id_number">{{ row.id_number }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="课卡扣次" v-if="isPc">
        <template v-slot="{ row }">
          <span v-if="row.card_id">{{ row.decrement_number | toYuan }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="剩余次数" v-if="isPc">
        <template v-slot="{ row }">
          <span v-if="row.is_number_limit">{{ row.expire_number | toYuan }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <v-column-time value="失效日期" field="expire_time" time-format="timeToYmd" empty-tip="-" sortable="" v-if="is2k"/>

      <el-table-column label="微信支付订单号" v-if="is2k">
        <template v-slot="{ row }">
          <span v-if="row.we_chat_order_id">{{ row.out_trade_no }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="实际支付金额" v-if="is2k">
        <template v-slot="{ row }">
          <span v-if="row.we_chat_order_id">{{ row.payer_total | toYuan }} 元</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="退款金额" v-if="is2k">
        <template v-slot="{ row }">
          <span v-if="row.we_chat_order_id">{{ row.payer_refund | toYuan }} 元</span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <el-table-column label="退款状态" v-if="is2k">
        <template v-slot="{ row }">
          <template v-if="row.refund_id">
            <el-tag v-if="row.is_reject" type="danger">申请失败</el-tag>
            <template v-else>
              <el-tag v-if="!row.status">申请中</el-tag>
              <template v-else>
                <el-tag
                  v-for="refundState in findRefundState(row.status)"
                  :key="`refundState${refundState.value}`"
                  :type="refundState.tagType"
                >
                  {{ refundState.name }}
                </el-tag>
              </template>
            </template>
          </template>

        </template>
      </el-table-column>

      <el-table-column label="预约状态">
        <template v-slot="{ row }">
          {{ (courseColumn.decrement_number && !row.card_id && !row.we_chat_order_id) ? '试课' : getReservationShortNameByState(row.reserve_state) }}
        </template>
      </el-table-column>

<!--      <el-table-column label="操作" width="504px">
        <template v-slot="{ row }">
          <v-list-button
            v-if="row.reserve_state === reserveStates.waitSignIn.value"
            name="取消预约"
            icon="sign-canceled"
            size="large"
            :is-last="true"
            @click="handleCancelReserve(row)"
            :is-loading="isCancellingIds.includes(row.id)"
            message="取消此次预约后，将返还预约所扣次数，确认要继续吗？"
          />
        </template>
      </el-table-column>-->


      <template slot="mobile-list">
        <section class="list">
          <template v-if="courseColumn.students.length">
            <div
              v-for="(v, k) in courseColumn.students"
              :key="`card-ticket-list-${k}-${v.id}`"
              class="list-item primary-background-light"
            >
              <div class="list-item-detail">
                <span>预约时间</span>
                <span>{{ v.reserve_time | timeToYmdHi }}</span>
              </div>

              <div class="list-item-detail">
                <span>排队时间</span>
                <span>{{ v.queue_time | timeToYmdHi }}</span>
              </div>

              <div class="list-item-detail">
                <span>所属学员</span>
                <v-avatar-nickname
                  :value="v.selfie"
                  :nickname="v.student_name"
                  :is-center="true"
                  :link-page-name="RouteConfig.studentDetail.name"
                  :link-page-id="v.id"
                  :avatar-size="50"
                  width="30vw"
                />
              </div>

              <div class="list-item-detail">
                <span>预约结束时间</span>
                <span>{{ v.end_time | timeToYmdHi }}</span>
              </div>

              <div class="list-item-detail">
                <span>所用课卡</span>
                <span v-if="v.card_id">{{ v.card_name }}</span>
                <span v-else>-</span>
              </div>

              <div class="list-item-detail">
                <span class="flex-shrink">身份证号</span>
                <span class="list-item-info">{{ v.id_number }}</span>
              </div>

              <div class="list-item-detail">
                <span>课卡扣次</span>
                <span v-if="v.card_id">{{ v.decrement_number | toYuan }}</span>
                <span v-else>-</span>
              </div>

              <div class="list-item-detail">
                <span>剩余次数</span>
                <span v-if="v.is_number_limit">{{ v.expire_number | toYuan }}</span>
                <span v-else>-</span>
              </div>

              <div class="list-item-detail">
                <span>失效日期</span>
                <span>{{ v.expire_time | timeToYmd }}</span>
              </div>

              <div class="list-item-detail">
                <span>微信支付订单号</span>
                <span v-if="v.we_chat_order_id">{{ v.out_trade_no }}</span>
                <span v-else>-</span>
              </div>

              <div class="list-item-detail">
                <span>实际支付金额</span>
                <span v-if="v.we_chat_order_id">{{ v.payer_total | toYuan }} 元</span>
                <span v-else>-</span>
              </div>

              <div class="list-item-detail">
                <span>退款金额</span>
                <span v-if="v.we_chat_order_id">{{ v.payer_refund | toYuan }} 元</span>
                <span v-else>-</span>
              </div>

              <div class="list-item-detail">
                <span>退款状态</span>
                <template v-if="v.refund_id">
                  <el-tag v-if="v.is_reject" type="danger">申请失败</el-tag>
                  <template v-else>
                    <el-tag v-if="!v.status">申请中</el-tag>
                    <template v-else>
                      <el-tag
                        v-for="refundState in findRefundState(v.status)"
                        :key="`refundState${refundState.value}`"
                        :type="refundState.tagType"
                      >
                        {{ refundState.name }}
                      </el-tag>
                    </template>
                  </template>
                </template>
              </div>

              <div class="list-item-detail">
                <span>预约状态</span>
                {{ (courseColumn.decrement_number && !v.card_id && !v.we_chat_order_id) ? '试课' : getReservationShortNameByState(v.reserve_state) }}
              </div>

              <div class="list-item-button">
                <v-list-button
                  v-if="v.reserve_state === reserveStates.waitSignIn.value"
                  name="取消预约"
                  icon="sign-canceled"
                  size="large"
                  :is-last="true"
                  @click="handleCancelReserve(v)"
                  :is-loading="isCancellingIds.includes(v.id)"
                  message="取消此次预约后，将返还预约所扣次数，确认要继续吗？"
                />
              </div>
            </div>
          </template>

          <v-empty :is-loading="isLoading" :length="courseColumn.students.length"/>
        </section>
      </template>
    </v-table>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import {
  reserveStates,
  isSignStates,
  getReservationShortNameByState
} from '@/enums/reserveStates';
import { mapGetters } from 'vuex';
import { show, cancelReserve } from '@/api/course-column';
import { removeArrayItem } from "@/utils";
import getQrCode from './getQrCode';
import { refundStates, findRefundState } from "@/enums/refundStates";

export default {
  name: RouteConfig.courseColumnManage.name,
  data: () => ({
    RouteConfig,
    reserveStates,
    findRefundState,
    isLoading: false,
    isDeleting: false,
    isGetting: {},
    isBrokingIds: [],
    isCancellingIds: [],
    isSigningIds: [],
    isRefundingIds: [],
    count: 0,
    qrCode: { src: '' },
    courseColumn: {
      course_column_name: '',
      start_time: '',
      student_number: '',
      student_count: '',
      wait_count: '',
      decrement_number: '',
      decrement_days: 0,
      course_count: 0,
      store_id: 0,
      store_name: '',
      students: [],
    },
    refundStates,
    queryList: {
      is_asc: 1,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
      'isPc',
      'is2k',
      'isMobile',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
  },
  methods: {
    getReservationShortNameByState,
    isSignStates,
    getQrCode,
    async show() {
      const { isError, data } = await show(this.id, 1, 1);
      if (isError) return;

      const { courseColumn } = this;
      Object.keys(data).forEach(key => {
        if (key in courseColumn) courseColumn[key] = data[key];
      });
    },
    async handleCancelReserve({ student_id }) {
      this.isCancellingIds.push(student_id);
      const { isError } = await cancelReserve(this.id, { student_id });
      removeArrayItem(this.isCancellingIds, student_id);
      if (!isError) this.show();
    },
  },
  beforeMount() {
    this.show();
  },
};
</script>

<style scoped>
  .last-form-item {
    margin-bottom: 0;
  }

  .count-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 18px;
  }

  .count-number {
    padding: 0 6px;
    font-weight: bold;
  }

  .sign-in-count {
    font-size: 28px;
    padding-bottom: 2px;
  }

</style>
